import React from 'react';
import styled from 'styled-components';

// Layout visual Universo MOB (banner navy + cards). Compartilhado por todas as telas de lista.
export const CYAN = '#1CA5D9';

export const PageWrap = styled.div`
    padding: 24px;
    display: flex;
    flex-direction: column;
    gap: 16px;
    background: #f1f5f9;
    min-height: 100%;
`;

const BannerBar = styled.div`
    background: linear-gradient(135deg, #071a2c 0%, #0d3350 100%);
    color: #fff;
    border-radius: 12px;
    padding: 20px 24px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 16px;
    box-shadow: 0 6px 18px rgba(7, 26, 44, 0.25);
`;

export const Card = styled.div`
    background: #fff;
    border: 1px solid #e2e8f0;
    border-radius: 12px;
    box-shadow: 0 1px 3px rgba(16, 24, 40, 0.08);
    overflow: hidden;
`;

export const CardHead = styled.div`
    padding: 14px 20px;
    border-bottom: 1px solid #eef2f6;
    display: flex;
    align-items: center;
    gap: 8px;
    font-weight: 600;
    color: #0f172a;
    font-size: 0.95rem;
`;

export const CardBody = styled.div`
    padding: 16px 20px;
`;

export const Chip = styled.span`
    background: rgba(28, 165, 217, 0.18);
    color: #8fd6f2;
    border: 1px solid rgba(28, 165, 217, 0.35);
    border-radius: 999px;
    padding: 4px 12px;
    font-size: 0.8rem;
    font-weight: 600;
    white-space: nowrap;
`;

export const CountBadge = styled.span`
    background: #eff6ff;
    color: #1CA5D9;
    border-radius: 999px;
    padding: 2px 10px;
    font-size: 0.75rem;
    font-weight: 700;
    margin-left: 6px;
`;

export function PageBanner({ icon: Icon, title, subtitle, right }) {
    return (
        <BannerBar>
            <div style={{ display: 'flex', alignItems: 'center', gap: 14 }}>
                {Icon && <Icon size={26} />}
                <div>
                    <div style={{ fontSize: '1.15rem', fontWeight: 700 }}>{title}</div>
                    {subtitle && <div style={{ fontSize: '0.8rem', opacity: 0.75 }}>{subtitle}</div>}
                </div>
            </div>
            {right && <div>{right}</div>}
        </BannerBar>
    );
}
